function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import Immutable from 'seamless-immutable';
import { createSelector } from 'reselect';
import any from 'ramda/src/any';
import clone from 'ramda/src/clone';
import equals from 'ramda/src/equals';
import filter from 'ramda/src/filter';
import find from 'ramda/src/find';
import forEachObjIndexed from 'ramda/src/forEachObjIndexed';
import isEmpty from 'ramda/src/isEmpty';
import isNil from 'ramda/src/isNil';
import map from 'ramda/src/map';
import merge from 'ramda/src/mergeRight';
import path from 'ramda/src/path';
import pathOr from 'ramda/src/pathOr';
import pipe from 'ramda/src/pipe';
import pluck from 'ramda/src/pluck';
import propEq from 'ramda/src/propEq';
import propOr from 'ramda/src/propOr';
import reject from 'ramda/src/reject';
import sum from 'ramda/src/sum';
import uniq from 'ramda/src/uniq';
import uniqWith from 'ramda/src/uniqWith';
import values from 'ramda/src/values';
import without from 'ramda/src/without';
import { ProductMetadataPricingPlansByIdSelector } from 'invision-core/src/components/metadata/products/products.selectors';
import i18n from 'invision-core/src/components/i18n/i18n';
import { translateFaultCode } from 'invision-core/src/api/api.fault.helper';
import { DiscretionaryDiscountsByCurrencySelector } from 'invision-core/src/components/metadata/discounts/discounts.selectors';
import { PageSizePreferenceSelector } from 'invision-core/src/components/session/session.selectors';
import { convertStringToNumber } from 'invision-core/src/components/helpers/conversion.helper';
import { PRODUCT_CLASSIFICATIONS } from 'invision-core/src/constants/product.constants';
import { MetadataCodeTypeSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { pascalCaseKeys } from 'invision-core/src/utilities/object.formatting.helper';
import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { isExpired } from '../../utilities/credit.card.helper';
import { PaymentInstrumentsCanBeUsedForOrderingContainingBalanceSelector } from './customer.ewallet.selectors';
import { EditSubscriptionItemSelector } from './customer.subscriptions.selectors';
import cloneDeep from 'lodash/cloneDeep';
import { STRUCTURE_TYPES } from '../constants/structure.type.constants';
import { ASYNC_STATUS_CONSTANTS } from '../constants/wizard.constants';
import { PRICING_PLAN_TYPES } from '../constants/pricingplan.type.constants';
import { getPricingPlanAvailabilityDate } from '../helpers/products.order.selector.helpers';
import { getFormattedInstancePropertiesForUI } from '../helpers/instance.property.helper';
import LocaleKeys from '../../locales/keys';
import { populateItemDetails, removeQuantities, SubscriptionQuoteForPreview } from './products.order.selectors.helper';
import { getButtonCount, setPricingPlanQuantities, setProductListItemSelected } from '../../components/customer/orders/create/productsOrder/steps/products/products.wizard.helper';
import { IsDbss } from 'invision-core/src/components/session/businessunit.selectors';
import { SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES } from '../../components/customer/ewallet/ewallet.constants';
import { EMPTY_ARRAY, EMPTY_OBJECT, FALSE } from '../constants/common.constants';
import { getFullCustomerAddress, formatSelectedStoreString } from '../helpers/customer.helper';
import { BILLER_RULE_CYCLE_LEVEL } from '../../customercare.constants';
var ADDITIONAL_PROPERTY_IS_ACTIVE = 'is_active';
var CONVERGENT_BILLER_INVOICE = Number(SUPPORTED_OTT_PAYMENT_INSTRUMENT_TYPES.CONVERGENT_BILLER_INVOICE);
var TAX_LOCATION_CONSTANTS = {
  CUSTOMER_ADDRESS: 2,
  DEFAULT: 1,
  NPA_NXX: 3,
  STORE_LOCATION: 4
};
var ProductOrderSelector = function ProductOrderSelector(state) {
  return state.customercare.productOrder;
};
var ProductOrderDataSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return pathOr(null, ['data'], productOrder);
});
var AvailableProductsDataSelector = createSelector([ProductOrderDataSelector], function (orderStoreData) {
  return orderStoreData.availableProducts.data;
});
var SelectedSeriesContainerSelector = createSelector([ProductOrderDataSelector], function (orderStoreData) {
  return orderStoreData.selectedSeriesContainer;
});
export var ProductOfferAsyncIdSelector = createImmutableSelector([ProductOrderSelector], function (productOfferWizard) {
  return productOfferWizard.asyncId;
});
export var ProductOfferAsyncStatusSelector = createImmutableSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.asyncStatus;
});
export var IsAsyncCompleteSelector = createImmutableSelector([ProductOfferAsyncIdSelector, ProductOfferAsyncStatusSelector], function (asyncId, asyncStatus) {
  return asyncId ? asyncStatus === ASYNC_STATUS_CONSTANTS.COMPLETE || asyncStatus === ASYNC_STATUS_CONSTANTS.FAILED : true;
});
export var CartItemDetailsSelector = createSelector([ProductOrderDataSelector], function (orderStoreData) {
  return orderStoreData.cartItemDetails;
});
export var IsShoppingCartLoadingSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.isCreatingOrUpdatingShoppingCart;
});
export var ProductsMapSelector = createSelector([AvailableProductsDataSelector], function (availableProductsData) {
  return availableProductsData.productsMap;
});
// productsMap above contains the products to display for the current page of the order search
// productsWithMetadata contains the metadata for all previously selected products
// - once the product modal loads, that product's metadata is added to productsWithMetadata and never removed
export var ProductsWithMetadataMapSelector = createSelector([ProductOrderDataSelector], function (productsOrderData) {
  return productsOrderData.productsWithMetadata;
});
export var AvailableProductsInstancePropertiesLabelSelector = createSelector([ProductsWithMetadataMapSelector], function (productsMap) {
  var instanceProperties = {};
  if (!isNil(productsMap)) {
    forEachObjIndexed(function (productDetails) {
      pathOr([], ['InstanceProperties'], productDetails).map(function (instanceProp) {
        instanceProperties[instanceProp.Id] = instanceProp.Name;
      });
    }, productsMap || {});
  }
  return instanceProperties;
});
export var SelectedProductIdSelector = createSelector([AvailableProductsDataSelector], function (availableProducts) {
  return availableProducts.selectedProductId;
});
export var HaveSelectedProductMetadata = createSelector([ProductsWithMetadataMapSelector, SelectedProductIdSelector], function (productsMetadataMap, selectedProductId) {
  return !!productsMetadataMap[selectedProductId];
});
export var EpisodesSelector = createSelector([AvailableProductsDataSelector], function (availableProducts) {
  return availableProducts.episodes;
});
export var OptionalProductsSelector = createSelector([AvailableProductsDataSelector], function (availableProducts) {
  return availableProducts.optionalProducts;
});
export var PicklistProductsSelector = createSelector([AvailableProductsDataSelector], function (availableProducts) {
  return availableProducts.picklistProducts;
});
export var SelectedProductSelector = createSelector([ProductsWithMetadataMapSelector, SelectedProductIdSelector], function (productsWithMetadataMap, selectedProductId) {
  return propOr(EMPTY_OBJECT, selectedProductId, productsWithMetadataMap); //http://ramdajs.com/docs/#propOr
});
export var SelectedProductDescriptionSelector = createSelector([SelectedProductSelector], function (selectedProduct) {
  return selectedProduct ? selectedProduct.ShortDescription || selectedProduct.Description : null;
});

// TODO Customer Order will need a better way to check for this, ideally with product template in the future for now check these product classes
export var IsSelectedProductDbss = createSelector([SelectedProductSelector], function (selectedProduct) {
  return selectedProduct.ProductClassification === PRODUCT_CLASSIFICATIONS.AD_HOC || selectedProduct.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE || selectedProduct.Classification === PRODUCT_CLASSIFICATIONS.AD_HOC || selectedProduct.Classification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE;
});

// TODO Customer Order, this is temporary to start build out of support for DBSS products ordering from products wizard that will later incorporate
// service feature, ad hocs, & standalones as visually for options and flows will be similar, for now this will just be for ad hocs, we can rename function later
export var IsSelectedProductAdHoc = createSelector([SelectedProductSelector], function (selectedProduct) {
  return selectedProduct.ProductClassification === PRODUCT_CLASSIFICATIONS.AD_HOC;
});
export var IsSelectedProductSeriesContainer = createSelector([SelectedSeriesContainerSelector], function (selectedSeriesContainer) {
  return selectedSeriesContainer.productId !== null;
});
export var SelectedSeriesContainerProductId = createSelector([SelectedSeriesContainerSelector], function (selectedSeriesContainer) {
  return selectedSeriesContainer.productId;
});
export var SavedOtherSeasonSelections = createSelector([SelectedSeriesContainerSelector], function (selectedSeriesContainer) {
  return selectedSeriesContainer.savedOtherSeasonSelectionsMap;
});
var ZERO_COUNT = 0;
export var OtherSeasonSelectionCount = createSelector([SavedOtherSeasonSelections, SelectedProductSelector], function (otherSeasons, selectedProduct) {
  if (!otherSeasons || !values(otherSeasons).length) {
    return ZERO_COUNT;
  }
  return values(otherSeasons).reduce(function (accumulator, season) {
    if (season.productId === selectedProduct.Id) {
      return accumulator;
    } else {
      return accumulator + (season.pricingPlanId ? season.quantity : season.selectedEpisodes ? season.selectedEpisodes.length * season.quantity : 0);
    }
  }, 0);
});
export var HasOtherSavedSeasonSelections = createSelector([OtherSeasonSelectionCount], function (count) {
  return !!count;
});
export var OtherSeasonsProductsToAdd = createSelector([SavedOtherSeasonSelections, SelectedProductSelector], function (otherSeasons, selectedProduct) {
  if (!otherSeasons) {
    return EMPTY_ARRAY;
  } else {
    return values(otherSeasons).reduce(function (accumulator, season) {
      if (season.productId === selectedProduct.Id) {
        return accumulator;
      } else {
        if (season.pricingPlanId) {
          return accumulator.concat({
            productId: season.productId,
            pricingPlanId: season.pricingPlanId,
            quantity: season.quantity
          });
        } else {
          return accumulator.concat((season.selectedEpisodes || []).map(function (episode) {
            return {
              productId: episode.productId,
              pricingPlanId: episode.pricingPlanId,
              quantity: season.quantity
            };
          }));
        }
      }
    }, []);
  }
});
export var HasSavedSeason = createSelector([SavedOtherSeasonSelections, SelectedProductSelector], function (otherSeasons, selectedProduct) {
  return !!(otherSeasons && otherSeasons[selectedProduct.Id]);
});
var SavedSeasonEpisodes = createSelector([SavedOtherSeasonSelections, SelectedProductSelector], function (otherSeasons, selectedProduct) {
  return !otherSeasons || !otherSeasons[selectedProduct.Id] ? EMPTY_ARRAY : otherSeasons[selectedProduct.Id].selectedEpisodes || EMPTY_ARRAY;
});
export var SeriesContainerEpisodicBundlesOptions = createSelector([SelectedSeriesContainerSelector], function (selectedSeriesContainer) {
  return selectedSeriesContainer.selectSeasonOptions.asMutable({
    deep: true
  });
});
export var SeriesContainerIncludedEpisodicBundles = createSelector([SelectedProductSelector, IsSelectedProductSeriesContainer], function (selectedProduct, isSeries) {
  if (isSeries && selectedProduct.ReferencedProducts) {
    var episodicBundles = values(selectedProduct.ReferencedProducts);
    return episodicBundles.map(function (episodicBundle) {
      return {
        product: episodicBundle
      };
    });
  } else {
    return EMPTY_ARRAY;
  }
});
export var IsSelectedProductServiceFeature = createSelector([SelectedProductSelector], function (selectedProduct) {
  return selectedProduct ? selectedProduct.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE : false;
});
export var SelectedProductGuidanceRatingsSelector = createSelector([SelectedProductSelector], function (selectedProduct) {
  if (isNil(selectedProduct) || isEmpty(selectedProduct)) {
    return null;
  }
  return selectedProduct.GuidanceRatings ? pluck('Name')(uniqWith(function (item1, item2) {
    return item1.Name === item2.Name;
  })(selectedProduct.GuidanceRatings)).join(', ') : null;
});
var ProductsDisplayOrderSelector = createSelector([AvailableProductsDataSelector], function (availableProductsData) {
  return availableProductsData.productsDisplayOrder;
});
export var ProductsSelector = createSelector([ProductsDisplayOrderSelector, ProductsMapSelector], function () {
  var displayOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var products = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return displayOrder ? displayOrder.map(function (productId) {
    return products[productId];
  }) : [];
});
export var SearchCatalogParamsSelector = createSelector([ProductOrderDataSelector], function (productOrder) {
  return Immutable.asMutable(productOrder.searchCatalogParams, {
    deep: true
  });
});
export var SearchCouponCodeSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.searchCatalogParams.ProductFilter.CouponCode;
});
export var ReplaceCartItemSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.replaceItem;
});
export var OrderQuoteSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return pathOr(undefined, ['quote'], productOrderData);
});
var SubscriptionShoppingCartSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.subscriptionShoppingCart;
});
export var ModifySubscriptionRequestDataSelector = createSelector([SubscriptionShoppingCartSelector], function (subscriptionShoppingCart) {
  return subscriptionShoppingCart.modifyRequestObject;
});
var SubscriptionAddItemsSelector = createSelector([ModifySubscriptionRequestDataSelector], function (subscriptionModifyRequestData) {
  return subscriptionModifyRequestData.AddItems;
});
var SubscriptionChangeItemsSelector = createSelector([ModifySubscriptionRequestDataSelector], function (subscriptionModifyRequestData) {
  return subscriptionModifyRequestData.ChangeItems;
});
var SubscriptionRemoveItemsSelector = createSelector([ModifySubscriptionRequestDataSelector], function (subscriptionModifyRequestData) {
  return subscriptionModifyRequestData.RemoveItems;
});
export var ModifiedSubscriptionItemSelector = createSelector([EditSubscriptionItemSelector, SubscriptionAddItemsSelector, SubscriptionChangeItemsSelector, SubscriptionRemoveItemsSelector, OrderQuoteSelector], function (originalEditItem, addItems, changeItems, removeItems, orderQuote) {
  var modifyCartItem = clone(originalEditItem);
  if (!isEmpty(modifyCartItem)) {
    if (modifyCartItem.Children && modifyCartItem.Children.length) {
      if (removeItems && removeItems.length) {
        modifyCartItem.Children = reject(function (cartChild) {
          return removeItems.includes(convertStringToNumber(cartChild.Id));
        }, modifyCartItem.Children);
      }
    }
    if (isNil(modifyCartItem.Children)) {
      modifyCartItem.Children = [];
    }
    if (addItems && addItems.length && orderQuote && orderQuote.Items && orderQuote.Items.length) {
      var addedQuoteItems = [];
      orderQuote.Items.forEach(function (quoteItem) {
        var foundAddedItem = find(function (addedItem) {
          return addedItem.ProductId === quoteItem.Product.Id && addedItem.PricingPlanId === quoteItem.PricingPlan.Id;
        }, addItems);
        if (foundAddedItem) {
          // upon parent PP changes (when ChangeImmediately) the PP of child items may be updated as well
          modifyCartItem.Children = reject(function (currentChild) {
            return currentChild.Product && currentChild.Product.Id === foundAddedItem.ProductId;
          }, modifyCartItem.Children);
          if (foundAddedItem.InstanceProperties && foundAddedItem.InstanceProperties.length) {
            var quoteItemWithInstanceProperties = Object.assign({}, {
              InstanceProperties: getFormattedInstancePropertiesForUI(foundAddedItem.InstanceProperties)
            }, quoteItem);
            addedQuoteItems.push(quoteItemWithInstanceProperties);
          } else {
            addedQuoteItems.push(quoteItem);
          }
        }
      });
      modifyCartItem.Children = modifyCartItem.Children.concat(addedQuoteItems);
    }
    if (changeItems && changeItems.length && originalEditItem.ChangeOptions && originalEditItem.ChangeOptions.length) {
      var selectedChangeOption = originalEditItem.ChangeOptions.find(function (changeOption) {
        // pricing plan change is currently the only supported change item so can use changeItems[0]
        return changeOption.PricingPlan && changeOption.PricingPlan.Id === changeItems[0].PricingPlanId;
      });
      if (selectedChangeOption) {
        modifyCartItem.PricingPlan = selectedChangeOption.PricingPlan;
      }
    }
  }
  return modifyCartItem;
});
export var ReplacementCartItemSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.replacementItem;
});
export var ShoppingCartIsDirtySelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.shoppingCartIsDirty;
});
export var ShoppingCartSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.shoppingCart;
});
export var ShoppingCartItemDetailsLocationCodesSelector = createSelector([ShoppingCartSelector], function (shoppingCart) {
  var items = shoppingCart.Items || [];
  var locationCodesArray = [];
  items.forEach(function (item) {
    var PricingPlanBillerRuleInstances = item.Details.PricingPlan.PricingPlanBillerRuleInstances;
    if (PricingPlanBillerRuleInstances) {
      PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances.forEach(function (bri) {
        if (bri.LocationCode && bri.LocationCode !== TAX_LOCATION_CONSTANTS.DEFAULT) {
          locationCodesArray.push(bri.LocationCode);
        }
      });
      PricingPlanBillerRuleInstances.RecurringBillerRuleInstances.forEach(function (bri) {
        if (bri.LocationCode && bri.LocationCode !== TAX_LOCATION_CONSTANTS.DEFAULT) {
          locationCodesArray.push(bri.LocationCode);
        }
      });
    }
  });
  return locationCodesArray.length ? uniq(locationCodesArray) : EMPTY_ARRAY;
});
export var DisplayTaxAndGlLocationsSelector = createImmutableSelector([ShoppingCartItemDetailsLocationCodesSelector], function (shoppingCartItemDetailsLocationCodes) {
  var displayTaxAndGlLocations = {};
  if (shoppingCartItemDetailsLocationCodes.length === 1) {
    displayTaxAndGlLocations.showCustomerAddressPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.CUSTOMER_ADDRESS);
    displayTaxAndGlLocations.showServiceIdentifierPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.NPA_NXX);
    displayTaxAndGlLocations.showStoreLocationPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.STORE_LOCATION);
  } else if (shoppingCartItemDetailsLocationCodes.length > 1) {
    displayTaxAndGlLocations.showCustomerAddressPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.CUSTOMER_ADDRESS) && !shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.NPA_NXX);
    displayTaxAndGlLocations.showServiceIdentifierPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.NPA_NXX) && !shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.CUSTOMER_ADDRESS);
    displayTaxAndGlLocations.showStoreLocationPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.STORE_LOCATION);
    displayTaxAndGlLocations.showCustomerAddressAndServiceIdentifierPicker = shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.CUSTOMER_ADDRESS) && shoppingCartItemDetailsLocationCodes.includes(TAX_LOCATION_CONSTANTS.NPA_NXX);
  }
  return displayTaxAndGlLocations;
});
export var ShoppingCartClassification = createSelector([ShoppingCartSelector], function (shoppingCart) {
  return pathOr(null, ['Items', 0, 'Details', 'Product', 'ProductClassification'], shoppingCart);
});
export var ShoppingCartCurrencySelector = createImmutableSelector([ShoppingCartSelector], function (shoppingCart) {
  return shoppingCart.Currency;
});
export var IsDbssShoppingCart = createSelector([ShoppingCartClassification], function (classification) {
  return classification === PRODUCT_CLASSIFICATIONS.AD_HOC;
});
export var ShoppingCartMetadataSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.shoppingCartProductsMetadata;
});
export var UngiftableShoppingCartItemSelector = createSelector([ShoppingCartMetadataSelector, ShoppingCartSelector], function (shoppingCartItemMetadata, shoppingCart) {
  return values(shoppingCartItemMetadata).filter(function (cartItemMetadata) {
    var shoppingCartItem = pathOr([], ['Items'], shoppingCart).find(function (cartItem) {
      return cartItemMetadata.Id === cartItem.ProductId;
    });
    var cartItemMetadataPricingPlan = pathOr([], ['PricingPlans'], cartItemMetadata).find(function (pricingPlan) {
      return pricingPlan.Id === path(['PricingPlanId'], shoppingCartItem);
    });
    return !pathOr(false, ['Giftable'], cartItemMetadataPricingPlan);
  });
});
export var InvalidItemsSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  if (productOrderData) {
    return productOrderData.invalidItems;
  }
  return [];
});
export var ShoppingCartErrorSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.shoppingCartError;
});
var OrderQuoteHasShippedItemsSelector = createSelector([OrderQuoteSelector], function (orderQuote) {
  return orderQuote && orderQuote.Items ? orderQuote.Items.some(function (quoteItem) {
    return pathOr(false, ['PricingPlan', 'Shipped'], quoteItem);
  }) : false;
});
export var OrderRequiresShippingSelector = createSelector([ShoppingCartSelector, OrderQuoteHasShippedItemsSelector, ModifiedSubscriptionItemSelector], function (shoppingCart, orderQuoteHasShippedItem, modifiedSubscriptionItem) {
  return pathOr(false, ['ShippingRequired'], shoppingCart) || orderQuoteHasShippedItem || pathOr(false, ['PricingPlan', 'Shipped'], modifiedSubscriptionItem);
});
export var OrderQuoteIsValidSelector = createSelector([OrderQuoteSelector], function (orderQuote) {
  return orderQuote.quoteIsValid;
});
export var OrderSubscriptionQuotesAsMutableSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return SubscriptionQuoteForPreview(productOrderData.subscriptionQuotes, productOrderData.quote);
});
export var OrderQuotePaymentInstrumentsSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.orderQuotePaymentInstruments;
});
export var OrderQuoteAmountAppliedSelector = createSelector([OrderQuotePaymentInstrumentsSelector], function (orderQuotePaymentInstruments) {
  return sum(without([undefined], pluck('Amount', orderQuotePaymentInstruments || []))).toFixed(2);
});
export var DoPaymentInstrumentsCoverOrderTotalSelector = createSelector([OrderQuoteAmountAppliedSelector, OrderQuoteSelector], function (appliedAmount, quote) {
  return appliedAmount >= quote.totalAmount;
});
export var DiscretionaryDiscountsReasonSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return pathOr(null, ['data', 'discretionaryDiscounts', 'reason'], productOrder);
});
export var DiscretionaryDiscountsIdSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return pathOr(null, ['data', 'discretionaryDiscounts', 'selectedIds'], productOrder);
});
export var DiscretionaryDiscountsSelector = createSelector([DiscretionaryDiscountsIdSelector, DiscretionaryDiscountsByCurrencySelector, ShoppingCartCurrencySelector], function (discretionaryDiscountsId, discretionaryDiscountsByCurrency, shoppingCartCurrency) {
  return map(function (discountId) {
    return find(propEq(Number(discountId), 'Id'), discretionaryDiscountsByCurrency[shoppingCartCurrency]);
  }, discretionaryDiscountsId || []).filter(function (discretionaryDiscounts) {
    return discretionaryDiscounts;
  });
});
export var CreatedOrderSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.createdOrder;
});
export var RemovedOrderSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.removedOrder;
});
export var UnfilteredCouponCodesSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.couponCodes;
});
export var CouponCodesSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.couponCodes.asMutable({
    deep: true
  }).filter(function (couponCode) {
    // in products.checkout.component.js description=null means the coupon is actively being validated
    return couponCode.description !== null;
  });
});
export var InvalidCouponRedemptionsSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.shoppingCartInvalidCoupons;
});
export var InvalidCouponRedemptionViewModelSelector = createSelector([InvalidCouponRedemptionsSelector], function (invalidCouponRedemptions) {
  return invalidCouponRedemptions.map(function (item) {
    var cloned = cloneDeep(item);
    cloned.translatedMessage = translateFaultCode(String(cloned.SubCode));
    return cloned;
  });
});
export var ShippingMethodsViewModel = createSelector([OrderQuoteSelector], function (orderQuote) {
  return orderQuote.ShippingMethods.map(function (shippingMethod) {
    return Object.assign({}, shippingMethod, {
      nameAndProviderLabel: shippingMethod.Provider ? "".concat(shippingMethod.Name, " (").concat(shippingMethod.Provider, ")") : shippingMethod.Name
    });
  });
});
export var SelectedProductBundleChildrenMapSelector = createSelector([SelectedProductSelector], function (selectedProduct) {
  if (isNil(selectedProduct)) {
    return EMPTY_OBJECT;
  }
  if (selectedProduct.BundleChildren && selectedProduct.BundleChildren.length > 0) {
    var bundleChildren = {};
    selectedProduct.BundleChildren.forEach(function (item) {
      bundleChildren[item.ProductId] = item;
    }, selectedProduct.BundleChildren);
    return bundleChildren;
  }
  return EMPTY_OBJECT;
});
export var PreviouslySelectedPaymentInstrumentIdsSelector = createSelector([ProductOrderDataSelector, OrderQuotePaymentInstrumentsSelector], function (productsOrderData, orderQuotePaymentInstruments) {
  if (orderQuotePaymentInstruments && orderQuotePaymentInstruments.length) {
    var validPreviouslySelectedPaymentInstrumentIds = [];
    productsOrderData.previouslySelectedPaymentInstrumentIds.forEach(function (previousPaymentId) {
      var foundPayment = orderQuotePaymentInstruments.find(function (orderQuotePaymentInstrument) {
        return orderQuotePaymentInstrument.Id === previousPaymentId;
      });
      if (foundPayment && foundPayment.Amount) {
        validPreviouslySelectedPaymentInstrumentIds.push(foundPayment.Id);
      }
    });
    return validPreviouslySelectedPaymentInstrumentIds;
  }
  return productsOrderData.previouslySelectedPaymentInstrumentIds;
});
export var SelectablePaymentInstrumentSelector = createSelector([PreviouslySelectedPaymentInstrumentIdsSelector, PaymentInstrumentsCanBeUsedForOrderingContainingBalanceSelector], function (previouslySelectedPaymentInstrumentIds, allUserOrderablePaymentInstruments) {
  return filter(function (paymentInstrument) {
    return previouslySelectedPaymentInstrumentIds.indexOf(paymentInstrument.Id) === -1 && !isExpired(paymentInstrument) && paymentInstrument.Id > 0;
  }, allUserOrderablePaymentInstruments);
});
export var SelectablePaymentInstrumentForServiceFeaturesSelector = createSelector([SelectablePaymentInstrumentSelector], function (paymentInstruments) {
  return paymentInstruments && paymentInstruments.length ? paymentInstruments.filter(function (instrument) {
    return instrument.Type !== CONVERGENT_BILLER_INVOICE;
  }) : [];
});
export var ProductBundleMappingSelector = createSelector([SelectedProductSelector, ProductsWithMetadataMapSelector], function (selectedProduct, productsWithMetadataMap) {
  if (!selectedProduct) {
    return EMPTY_ARRAY;
  }

  //With no bundle children there will be no optional products
  if (!selectedProduct.BundleChildren || selectedProduct.BundleChildren.length === 0) {
    return EMPTY_ARRAY;
  }

  //With no referenced products there will be no associated data for the bundle children
  if (!selectedProduct.ReferencedProducts || selectedProduct.ReferencedProducts.length === 0) {
    return EMPTY_ARRAY;
  }

  //With no product or bundle contexts, there will be no possibility of matching pricing plans
  if (!selectedProduct.ProductContext || !selectedProduct.ProductContext.BundleContexts || selectedProduct.ProductContext.BundleContexts.length === 0) {
    return EMPTY_ARRAY;
  }
  var bundles = filter(function (item) {
    return item.StructureType === STRUCTURE_TYPES.PRODUCT;
  }, selectedProduct.BundleChildren);
  if (!bundles || bundles.length === 0) {
    return EMPTY_ARRAY;
  }
  return bundles.map(function (bundle) {
    var bundleContext = find(function (bundleContext) {
      return bundleContext.Id === bundle.Id;
    }, selectedProduct.ProductContext.BundleContexts) || {};
    var planContext = bundleContext.OrderablePricingPlans || {};
    var planMap = {};
    var discountMap = {};
    var keys = Object.keys(planContext);
    var _loop = function _loop() {
      var prop = _keys[_i];
      var currentContext = planContext[prop];
      if (!isNil(currentContext)) {
        var matchingPlan = find(function (targetPlan) {
          return targetPlan.Id === currentContext.Id;
        }, bundle.PricingPlans);
        if (!isNil(matchingPlan)) {
          planMap[prop] = matchingPlan.merge({
            availabilityDate: getPricingPlanAvailabilityDate(propOr(null, 'AvailabilityStart', matchingPlan))
          });

          //Sometimes DiscountAmount is not present and sometimes it is but matches ChargeAmount depending on bundle type
          //Since there is a lack of consistency across plan context structures, need to check both scenarios
          if (!isNil(currentContext.DiscountedAmount) && currentContext.DiscountedAmount !== matchingPlan.ChargeAmount) {
            discountMap[prop] = currentContext.DiscountedAmount;
          }
        }
      }
    };
    for (var _i = 0, _keys = keys; _i < _keys.length; _i++) {
      _loop();
    }
    var referencedProduct = productsWithMetadataMap[bundle.ProductId] || selectedProduct.ReferencedProducts[bundle.ProductId];
    if (!referencedProduct) {
      return;
    }
    var bundleItem = {
      bundle: bundle,
      product: referencedProduct,
      pricingPlans: planMap,
      discounts: discountMap
    };
    return bundleItem;
  }) || EMPTY_ARRAY;
});
export var IncludedEpisodesSelector = createSelector([SelectedProductSelector, SelectedProductBundleChildrenMapSelector, EpisodesSelector, ProductsWithMetadataMapSelector], function (selectedProduct, bundleMaps, selectedEpisodes, productsWithMetadataMap) {
  if (!selectedProduct) {
    return EMPTY_ARRAY;
  }

  //With no bundle children there will be no optional products
  if (!selectedProduct.BundleChildren || selectedProduct.BundleChildren.length === 0) {
    return EMPTY_ARRAY;
  }

  //With no referenced products there will be no associated data for the bundle children
  if (!selectedProduct.ReferencedProducts || selectedProduct.ReferencedProducts.length === 0) {
    return EMPTY_ARRAY;
  }

  //With no product or bundle contexts, there will be no possibility of matching pricing plans
  if (!selectedProduct.ProductContext || !selectedProduct.ProductContext.EpisodicContext || selectedProduct.ProductContext.EpisodicContext.length === 0) {
    return EMPTY_ARRAY;
  }
  if (!bundleMaps || bundleMaps.length === 0) {
    return EMPTY_ARRAY;
  }
  var bundleItems = [];
  selectedProduct.ProductContext.EpisodicContext.forEach(function (episodicContext) {
    var bundle = bundleMaps[episodicContext.ProductId];
    var planMap = {};
    bundle.PricingPlans.forEach(function (bundlePricingPlan) {
      planMap[bundlePricingPlan.Id] = bundlePricingPlan;
      var matchedOrderablePricingPlans = filter(function (opp) {
        return equals(bundlePricingPlan.Id, opp.Id);
      }, episodicContext.OrderablePricingPlans || []);
      if (matchedOrderablePricingPlans.length > 0) {
        planMap[bundlePricingPlan.Id] = Object.assign({}, planMap[bundlePricingPlan.Id], {
          discountedAmount: path(['DiscountedAmount'], matchedOrderablePricingPlans[0])
        });
      }
    });
    var referencedProduct = productsWithMetadataMap[episodicContext.ProductId] || selectedProduct.ReferencedProducts[episodicContext.ProductId];
    if (!referencedProduct) {
      return;
    }
    var selectedItem = selectedEpisodes[bundle.ProductId];
    bundleItems.push(Object.assign({}, selectedItem, {
      bundle: bundle,
      entitledPricingPlanId: episodicContext.EntitledPricingPlanId,
      product: referencedProduct,
      pricingPlans: planMap
    }));
  });
  return bundleItems;
});
export var SelectedShoppingCartItemIndexSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.data.selectedCartItemIndex;
});
export var SelectedCartItemQuantitySelector = createSelector([SelectedShoppingCartItemIndexSelector, ShoppingCartSelector], function (shoppingCartItemIndex, shoppingCart) {
  return shoppingCart.Items && shoppingCart.Items.length && shoppingCartItemIndex !== null && shoppingCart.Items[shoppingCartItemIndex] ? shoppingCart.Items[shoppingCartItemIndex].Quantity : 1;
});
export var SelectedCartItemPricingPlanIdSelector = createSelector([SelectedShoppingCartItemIndexSelector, ShoppingCartSelector], function (shoppingCartItemIndex, shoppingCart) {
  return shoppingCart.Items && shoppingCart.Items.length && shoppingCartItemIndex !== null && shoppingCart.Items[shoppingCartItemIndex] ? shoppingCart.Items[shoppingCartItemIndex].PricingPlanId : null;
});
export var IncludedProductsSelector = createSelector([ProductBundleMappingSelector, SelectedProductSelector, SelectedShoppingCartItemIndexSelector, ShoppingCartSelector, ModifiedSubscriptionItemSelector], function (bundleMaps, selectedProduct, shoppingCartItemIndex, shoppingCart, subscriptionItem) {
  if (!bundleMaps || bundleMaps.length === 0) {
    return EMPTY_ARRAY;
  }
  if (!selectedProduct || !selectedProduct.ReferencedProducts || !selectedProduct.ProductContext || !selectedProduct.ProductContext.BundleContexts || selectedProduct.ProductContext.BundleContexts.length === 0) {
    return EMPTY_ARRAY;
  }
  var targetItems = filter(function (bundleItem) {
    return bundleItem.bundle.StructureType === STRUCTURE_TYPES.PRODUCT && bundleItem.bundle.MinimumQuantity === bundleItem.bundle.MaximumQuantity;
  }, bundleMaps) || EMPTY_ARRAY;
  var cartItem = shoppingCart && shoppingCart.Items && shoppingCart.Items.length && !isNil(shoppingCartItemIndex) ? shoppingCart.Items[shoppingCartItemIndex] : null;
  targetItems.forEach(function (currentItem) {
    if (path(['ChildItems', 'length'], cartItem)) {
      var match = find(function (childItem) {
        return childItem.ProductId === currentItem.product.Id;
      }, cartItem.ChildItems);
      if (!isNil(match) && !isNil(match.InstanceProperties)) {
        currentItem.instanceProperties = match.InstanceProperties.asMutable({
          deep: true
        });
      }
    } else if (path(['Children', 'length'], subscriptionItem)) {
      var _match = find(function (childItem) {
        return childItem.Product.Id === currentItem.product.Id;
      }, subscriptionItem.Children);
      if (!isNil(_match) && !isNil(_match.InstanceProperties)) {
        currentItem.instanceProperties = _match.InstanceProperties;
      }
    }
  });
  return targetItems;
});
export var IndividualEpisodesViewModelSelector = createSelector([IncludedEpisodesSelector, SavedSeasonEpisodes], function (includedEpisodes, savedSeasonEpisodes) {
  if (isNil(includedEpisodes) || includedEpisodes.length === 0) {
    return EMPTY_ARRAY;
  }
  return includedEpisodes.map(function (episode) {
    var matchingProduct = savedSeasonEpisodes.find(function (savedEpisode) {
      return savedEpisode.productId === episode.product.Id;
    });
    var item = merge(clone(episode), {
      //Since this is a view model returned by another selector, cloning so we don't affect other references
      isSelected: !!matchingProduct,
      purchasedPlans: [],
      instanceProperties: {},
      selectedPlanId: matchingProduct ? matchingProduct.pricingPlanId : null
    });

    //filter the pricing plans to just the purchaseable type
    item.pricingPlans = filter(function (plan) {
      return plan.Type === PRICING_PLAN_TYPES.ORDERABLE;
    }, item.pricingPlans);
    item.pricingPlans = map(function (plan) {
      return merge(clone(plan), {
        availabilityDate: getPricingPlanAvailabilityDate(propOr(null, 'AvailabilityStart', plan))
      });
    }, item.pricingPlans);
    if (item.entitledPricingPlanId !== null) {
      var matchingPlan = item.pricingPlans[item.entitledPricingPlanId];
      if (!isNil(matchingPlan)) {
        item.purchasedPlans.push(matchingPlan);
      }
    }
    return item;
  });
});
var CurrentEpisodicProductIdsSelector = createSelector([IndividualEpisodesViewModelSelector], function (individualEpisodes) {
  return individualEpisodes.map(function (episode) {
    return episode.product.Id;
  });
});
var DEFAULT_EPISODIC_PRODUCT_IDS = [];
export var RemainingEpisodicProductIdsSelector = createSelector([SelectedProductSelector, CurrentEpisodicProductIdsSelector], function (productOrder, currentEpisodeProductIds) {
  if (!productOrder || !productOrder.BundleChildren) {
    return DEFAULT_EPISODIC_PRODUCT_IDS;
  }
  return productOrder.BundleChildren.filter(function (product) {
    return !currentEpisodeProductIds.some(function (episodeProductId) {
      return episodeProductId === convertStringToNumber(product.ProductId);
    });
  }).map(function (product) {
    return convertStringToNumber(product.ProductId);
  });
});
export var OptionalProductsViewModelSelector = createSelector([ProductBundleMappingSelector, SelectedShoppingCartItemIndexSelector, ShoppingCartSelector, SelectedProductIdSelector, ModifiedSubscriptionItemSelector], function (bundleMap, shoppingCartItemIndex, shoppingCart, selectedProductId, subscriptionItem) {
  var cartItem = shoppingCart && shoppingCart.Items && shoppingCart.Items.length && !isNil(shoppingCartItemIndex) ? shoppingCart.Items[shoppingCartItemIndex] : null;
  var subscriptionProductId = pathOr(null, ['Product', 'Id'], subscriptionItem);
  var filteredItems = filter(function (bundleItem) {
    return bundleItem.bundle.MaximumQuantity > bundleItem.bundle.MinimumQuantity;
  }, bundleMap);
  return filteredItems.map(function (bundleItem) {
    var optionalItem = Object.assign(bundleItem, {
      isSelected: false,
      quantity: bundleItem.bundle.DefaultQuantity
    });
    if (cartItem) {
      var match = find(function (childItem) {
        return childItem.ProductId === optionalItem.product.Id;
      }, cartItem.ChildItems || []);
      if (!isNil(match)) {
        optionalItem.instanceProperties = match.InstanceProperties;
        optionalItem.isSelected = true;
        optionalItem.quantity = match.Quantity;
      } else {
        optionalItem.quantity = 0; //Editing and product was not in cart so quantity goes to 0
      }
    } else if (subscriptionProductId && subscriptionProductId === selectedProductId) {
      var matches = [];
      if (subscriptionItem && subscriptionItem.Children) {
        matches = filter(function (sourceItem) {
          return sourceItem.Product.Id === optionalItem.bundle.ProductId;
        }, subscriptionItem.Children);
      }
      if (!isNil(matches) && matches.length > 0) {
        optionalItem.instanceProperties = matches[0].InstanceProperties;
        optionalItem.isSelected = true;
        optionalItem.quantity = matches.length;
        optionalItem.originallySelected = !isNil(matches[0].OrderNumber);
      } else {
        optionalItem.quantity = 0;
        optionalItem.originallySelected = false;
      }
    } else {
      if (optionalItem.bundle.DefaultQuantity > 0) {
        optionalItem.isSelected = true;
      }
    }
    return bundleItem;
  });
});
var PicklistViewModelInputsAreValid = function PicklistViewModelInputsAreValid(selectedProduct) {
  if (isNil(selectedProduct)) {
    return false;
  }

  //With no bundle children there will be no optional products
  if (!selectedProduct.BundleChildren || selectedProduct.BundleChildren.length === 0) {
    return false;
  }

  //With no referenced products there will be no associated data for the bundle children
  if (!selectedProduct.ReferencedProducts || selectedProduct.ReferencedProducts.length === 0) {
    return false;
  }

  //With no product or bundle contexts, there will be no possibility of matching pricing plans
  if (isNil(selectedProduct.ProductContext) || isNil(selectedProduct.ProductContext.BundleContexts) || selectedProduct.ProductContext.BundleContexts.length === 0) {
    return false;
  }
  return true;
};
export var PicklistProductsViewModelSelector = createSelector([SelectedProductSelector, SelectedShoppingCartItemIndexSelector, ShoppingCartSelector, PicklistProductsSelector, ModifiedSubscriptionItemSelector], function (selectedProduct, shoppingCartItemIndex, shoppingCart, selectedPicklistProducts, subscriptionItem) {
  if (!PicklistViewModelInputsAreValid(selectedProduct)) {
    return EMPTY_ARRAY;
  }
  var bundles = filter(function (item) {
    return item.StructureType === STRUCTURE_TYPES.PICKLIST;
  }, selectedProduct.BundleChildren);
  if (isNil(bundles) || isEmpty(bundles)) {
    return EMPTY_ARRAY;
  }
  var cartItem = shoppingCart && shoppingCart.Items && shoppingCart.Items.length && !isNil(shoppingCartItemIndex) ? shoppingCart.Items[shoppingCartItemIndex] : null;
  var subscriptionProductId = pathOr(null, ['Product', 'Id'], subscriptionItem);
  var productItems = [];
  bundles.forEach(function (bundle) {
    if (bundle.PicklistOptions) {
      var bundleContext = find(function (bundleContext) {
        return bundleContext.Id === bundle.Id;
      }, selectedProduct.ProductContext.BundleContexts) || {};
      var planContext = bundleContext.PicklistOrderablePricingPlans || {};
      bundle.PicklistOptions.forEach(function (pickOption) {
        var planMap = {};
        var discountMap = {};
        var referencedProduct = selectedProduct.ReferencedProducts[pickOption.ProductId];
        if (isNil(referencedProduct)) {
          return;
        }
        selectedProduct.PricingPlans.forEach(function (productPlan) {
          var pickPlan = find(function (pickPlanContext) {
            return pickPlanContext.ProductId === pickOption.ProductId;
          }, planContext[productPlan.Id] || []);
          if (isNil(pickPlan) || isNil(pickPlan.OrderablePricingPlans) || pickPlan.OrderablePricingPlans.length === 0) {
            return;
          }

          //The OrderablePricingPlans "collection" on pick list items only ever contains 1.
          var pickPlanContext = pickPlan.OrderablePricingPlans[0];
          var matchingPlan = find(function (pricingPlan) {
            return pricingPlan.Id === pickPlanContext.Id;
          }, pickOption.PricingPlans);
          if (!isNil(matchingPlan)) {
            planMap[productPlan.Id] = matchingPlan.merge({
              availabilityDate: getPricingPlanAvailabilityDate(propOr(null, 'AvailabilityStart', matchingPlan))
            });
            if (!isNil(pickPlanContext.DiscountedAmount) && pickPlanContext.DiscountedAmount !== matchingPlan.ChargeAmount) {
              discountMap[productPlan.Id] = pickPlanContext.DiscountedAmount;
            }
          }
        });
        var productItem = {
          isSelected: false,
          bundle: bundle,
          product: referencedProduct,
          pricingPlans: planMap,
          discounts: discountMap
        };
        if (cartItem && cartItem.ChildItems && cartItem.ChildItems.length) {
          var match = find(function (childItem) {
            return childItem.ProductId === productItem.product.Id;
          }, cartItem.ChildItems);
          if (match) {
            productItem.isSelected = true;
          }
        } else if (subscriptionProductId && subscriptionProductId === selectedProduct.Id) {
          productItem.isSelected = pipe(pluck('Product'), pluck('Id'), any(function (id) {
            return id === pickOption.ProductId;
          }))(pathOr([], ['Children'], subscriptionItem));
        }
        var selectedItem = selectedPicklistProducts[productItem.product.Id];
        productItems.push(Object.assign({}, productItem, selectedItem));
      });
    }
  });
  return productItems.length > 0 ? productItems : EMPTY_ARRAY;
});
export var PicklistSelectionMessageSelector = createSelector([PicklistProductsViewModelSelector], function (picklistItems) {
  if (!isNil(picklistItems) && picklistItems.length > 0) {
    var bundle = picklistItems[0].bundle;
    var min = bundle.MinimumQuantity;
    var max = bundle.MaximumQuantity;
    var messageParams = {
      min: min,
      max: max
    };
    if (min === 0 && max === 0) {
      //No min or max
      return i18n.translate(LocaleKeys.SELECTABLE_ITEMS.FROM);
    } else if (min > max) {
      //No max
      return i18n.translate(LocaleKeys.SELECTABLE_ITEMS.AT_LEAST, messageParams);
    } else if (min === 0 && max > min) {
      //No min
      return i18n.translate(LocaleKeys.SELECTABLE_ITEMS.AT_MOST, messageParams);
    } else if (min === max) {
      //Min and max are the same (exact number)
      return i18n.translate(LocaleKeys.SELECTABLE_ITEMS.EXACTLY, messageParams);
    } else {
      //Both min and max
      return i18n.translate(LocaleKeys.SELECTABLE_ITEMS.BETWEEN, messageParams);
    }
  } else {
    return null;
  }
});
export var IsFetchingSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.isFetchingData || productOrder.isFetchingProductContext || productOrder.isFetchingDataAndProductContext;
});
export var IsFetchingOrderableProductData = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.isFetchingOrderableProductData || productOrder.isFetchingBatchMetadata;
});
export var IsFetchingSingleProductContext = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.isFetchingSingleProductContext;
});
export var IsSubmittingOrderSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.isSubmittingOrder;
});
export var IsCalculatingQuoteSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.isCalculatingQuote;
});
export var IsValidatingCoupon = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.couponCodes.some(function (couponCode) {
    return couponCode.description === null;
  });
});
export var ViewLastAttemptErrorSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.lastAttemptError;
});
export var PageNumberSelector = createSelector([AvailableProductsDataSelector], function (availableProductsData) {
  return availableProductsData.pageNumber;
});
export var RecordCountSelector = createSelector([AvailableProductsDataSelector], function (availableProductsData) {
  return availableProductsData.recordCount;
});
export var StartRecordSelector = createSelector([PageNumberSelector, PageSizePreferenceSelector], function (pageNumber, pageSize) {
  return (pageNumber - 1) * pageSize + 1;
});
export var EndRecordSelector = createSelector([RecordCountSelector, PageNumberSelector, PageSizePreferenceSelector], function (recordCount, pageNumber, pageSize) {
  var endNumber = pageNumber * pageSize;
  if (endNumber < recordCount) {
    return endNumber;
  }
  return recordCount;
});
export var NumberOfPagesSelector = createSelector([RecordCountSelector, PageSizePreferenceSelector], function (recordCount, pageSize) {
  return Math.ceil(recordCount / pageSize);
});
export var AddItemsSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return pathOr([], ['serviceFeatureQuote', 'AddItems'], productOrderData);
});
export var RemoveItemsSelector = createSelector([ProductOrderDataSelector], function (productOrderData) {
  return pathOr([], ['serviceFeatureQuote', 'RemoveItems'], productOrderData);
});
export var SubmitChangeOfServiceForServiceFeatureRequestSelector = createSelector([CartItemDetailsSelector, AddItemsSelector, RemoveItemsSelector, OrderQuoteSelector], function (cartItemDetails, addItems, removeItems, quote) {
  return {
    AddItems: populateItemDetails(addItems, cartItemDetails, quote),
    RemoveItems: populateItemDetails(removeItems, cartItemDetails, quote)
  };
});
export var SubmitChangeOfServiceForServiceFeatureWithoutQuantitiesRequestSelector = createSelector([SubmitChangeOfServiceForServiceFeatureRequestSelector], function (request) {
  return {
    AddItems: removeQuantities(request.AddItems),
    RemoveItems: removeQuantities(request.RemoveItems)
  };
});
export var IsServiceFeatureShoppingCart = createSelector([ShoppingCartClassification, SubmitChangeOfServiceForServiceFeatureRequestSelector], function (classification, submitChangeOfServiceRequest) {
  return classification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE || !!(submitChangeOfServiceRequest.RemoveItems && submitChangeOfServiceRequest.RemoveItems.length);
});
export var HasPrepaidPricingPlanSelector = createSelector([SubmitChangeOfServiceForServiceFeatureRequestSelector], function (submitChangeOfServiceRequest) {
  return !!(submitChangeOfServiceRequest.AddItems && submitChangeOfServiceRequest.AddItems.length ? submitChangeOfServiceRequest.AddItems.find(function (item) {
    return pathOr(false, ['Details', 'PricingPlan', 'Prepaid'], item);
  }) : false || submitChangeOfServiceRequest.RemoveItems && submitChangeOfServiceRequest.RemoveItems.length ? submitChangeOfServiceRequest.RemoveItems.find(function (item) {
    return pathOr(false, ['Details', 'PricingPlan', 'Prepaid'], item);
  }) : false);
});
export var ProductOrderDataListSelector = createSelector([ProductsSelector, ShoppingCartSelector], function (productOrder, shoppingCart) {
  var products = productOrder.length ? productOrder.asMutable({
    deep: true
  }) : [];
  var newProducts = products.length ? products.map(function (product) {
    product.isSelected = false;
    product.buttonCount = 0;
    return product;
  }) : [];
  var productsAreServiceFeatures = products.length ? products.find(function (product) {
    return product.ProductClassification === PRODUCT_CLASSIFICATIONS.SERVICE_FEATURE;
  }) : false;
  if (productsAreServiceFeatures && newProducts.length) {
    setProductListItemSelected(shoppingCart, newProducts);
    getButtonCount(shoppingCart, newProducts);
    setPricingPlanQuantities(shoppingCart, newProducts);
  }
  return newProducts.length ? Object.keys(newProducts).map(function (key) {
    return newProducts[key];
  }) : [];
});
export var ShouldShowNoConfiguredProductsMessageSelector = createSelector([IsFetchingSelector, ProductOrderDataListSelector, SearchCatalogParamsSelector], function (isFetchingData, productData, searchCatalogParams) {
  return !isFetchingData && productData.length === 0 && !searchCatalogParams.ProductFilter.CouponCode && !searchCatalogParams.SearchString && searchCatalogParams.ProductFilter.Facets.length === 0 && searchCatalogParams.ProductFilter.Categories.length === 0 && searchCatalogParams.ProductFilter.StructureTypes.length === 0;
});
export var SkipToCheckoutSelector = createSelector([ProductOrderSelector], function (productOrder) {
  return path(['data', 'skipToCheckout'], productOrder);
});
export var ProductDialogErrorMessagesSelector = createSelector([ShoppingCartErrorSelector], function (shoppingCartError) {
  return shoppingCartError && [shoppingCartError.message];
});
export var OrderablePricingPlansSelector = createSelector([SelectedProductSelector], function (selectedProduct) {
  return pathOr([], ['ProductContext', 'OrderablePricingPlans'], selectedProduct);
});
export var OptionalProductsConfigurationViewModelSelector = createSelector([OptionalProductsViewModelSelector], function (optionalProducts) {
  return {
    showInstruction: false,
    minQuantity: 0,
    maxQuantity: 0,
    usePlanSelection: false,
    showPurchasedPlans: false,
    usePerItemQuantity: true,
    items: optionalProducts
  };
});
export var PicklistProductsConfigurationViewModelSelector = createSelector([PicklistProductsViewModelSelector], function (picklistProducts) {
  var result = {
    showInstruction: true,
    minQuantity: 0,
    maxQuantity: 0,
    usePlanSelection: false,
    showPurchasedPlans: false,
    items: picklistProducts
  };
  if (!isNil(picklistProducts) && picklistProducts.length > 0) {
    result.minQuantity = result.items[0].bundle.MinimumQuantity;
    result.maxQuantity = result.items[0].bundle.MaximumQuantity;
  }
  return result;
});
export var IndividualEpisodesConfigurationViewModelSelector = createSelector([IndividualEpisodesViewModelSelector], function (individualEpisodes) {
  return {
    mappedPricingPlanId: null,
    showInstruction: false,
    minQuantity: 1,
    maxQuantity: 0,
    usePlanSelection: true,
    showPurchasedPlans: true,
    items: individualEpisodes
  };
});
var ProductsSortOptions = createSelector([ProductOrderDataSelector], function (productOrder) {
  return productOrder.productsSortOptions;
});
export var SelectedProductsSortOption = createSelector([ProductOrderDataSelector], function (orderStoreData) {
  return orderStoreData.selectedProductsSortOption;
});
export var ProductsSortOptionsFormattedSelector = createSelector([ProductsSortOptions, SelectedProductsSortOption], function (productSortoptions, selectedProductsSortOption) {
  var productsSortOptions = [];
  productSortoptions.forEach(function (sortOption) {
    var clonedSortOption = clone(sortOption);
    clonedSortOption.text = i18n.translate(clonedSortOption.key);
    if (clonedSortOption.value === selectedProductsSortOption.value && clonedSortOption.direction === selectedProductsSortOption.direction) {
      clonedSortOption.selected = true;
    }
    productsSortOptions.push(clonedSortOption);
  });
  return productsSortOptions;
});
export var InventoryRegionFilterSelector = createImmutableSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.inventoryStore.regionFilter;
});
export var FormattedInventoryStoresSelector = createImmutableSelector([MetadataCodeTypeSelector(CODES.Stores)], function (stores) {
  var activeStores = stores.filter(function (store) {
    return store.AdditionalProperties.find(function (additionalProperty) {
      return additionalProperty.Key === ADDITIONAL_PROPERTY_IS_ACTIVE;
    }).Value !== FALSE;
  });
  return activeStores.map(function (store) {
    return Object.assign({}, store, {
      AdditionalProperties: pascalCaseKeys(store.AdditionalProperties.reduce(function (additionalProperties, property) {
        additionalProperties[property.Key] = property.Value;
        return additionalProperties;
      }, {}))
    });
  });
});
export var InventoryStoresTableDataSelector = createImmutableSelector([InventoryRegionFilterSelector, FormattedInventoryStoresSelector], function (regionFilter, stores) {
  return stores.reduce(function (storesTableData, store) {
    if (regionFilter && store.AdditionalProperties.RegionCode !== regionFilter) {
      return storesTableData;
    }
    storesTableData.push({
      address: "".concat(store.AdditionalProperties.LineOne, " ").concat(store.AdditionalProperties.LineTwo),
      city: store.AdditionalProperties.City,
      description: store.Description,
      displayName: store.AdditionalProperties.DisplayName,
      name: store.Name,
      postalCode: store.AdditionalProperties.Zipcode,
      region: store.AdditionalProperties.RegionCode,
      stateProvince: store.AdditionalProperties.StateProvince,
      storeId: store.Value
    });
    return storesTableData;
  }, []);
});
export var SelectedInventoryStoreSelector = createImmutableSelector([ProductOrderDataSelector], function (productOrderData) {
  return pathOr(null, ['inventoryStore', 'selectedStore'], productOrderData);
});
export var SelectedInventoryStoreDetailsSelector = createImmutableSelector([SelectedInventoryStoreSelector, FormattedInventoryStoresSelector], function (selectedStoreId, storesDetails) {
  return selectedStoreId ? storesDetails.find(function (store) {
    return store.Value === selectedStoreId;
  }) : null;
});
export var SelectedInventoryStoreNameSelector = createImmutableSelector([SelectedInventoryStoreDetailsSelector], function (selectedInventoryStoreDetails) {
  return formatSelectedStoreString(selectedInventoryStoreDetails);
});
export var ServiceIdentifiersDataSelector = createImmutableSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.serviceIdentifiersData;
});
export var ServiceIdentifiersListSelector = createImmutableSelector([ServiceIdentifiersDataSelector], function (serviceIdentifiersData) {
  return serviceIdentifiersData.serviceIdentifiersList;
});
export var SelectedServiceIdentifierSelector = createImmutableSelector([ServiceIdentifiersDataSelector], function (serviceIdentifiersData) {
  if (!isEmpty(serviceIdentifiersData.selectedServiceIdentifier)) {
    return serviceIdentifiersData.selectedServiceIdentifier;
  } else {
    return null;
  }
});
export var CustomerAddressesDataSelector = createImmutableSelector([ProductOrderDataSelector], function (productOrderData) {
  return productOrderData.customerAddressesData;
});
export var FormattedCustomersAddressesListSelector = createImmutableSelector([CustomerAddressesDataSelector], function (customerAddressesData) {
  var formattedCustomerAddressesWithID = [];
  if (customerAddressesData.customerAddressesList) {
    customerAddressesData.customerAddressesList.forEach(function (address) {
      var formattedCustomerAddresses = {};
      formattedCustomerAddresses.addressId = address.Id;
      formattedCustomerAddresses.fullAddress = getFullCustomerAddress(address);
      formattedCustomerAddressesWithID.push(formattedCustomerAddresses);
    });
  }
  return formattedCustomerAddressesWithID;
});
export var SelectedCustomerAddressSelector = createImmutableSelector([CustomerAddressesDataSelector], function (customerAddressesData) {
  if (!isEmpty(customerAddressesData.selectedCustomerAddress)) {
    return customerAddressesData.selectedCustomerAddress;
  } else {
    return null;
  }
});
export var CartContainsProductWithBillerRuleCycleLevelOtherThanItemSelector = createImmutableSelector([ShoppingCartSelector, ProductMetadataPricingPlansByIdSelector, IsDbss], function (shoppingCart, productMetadataPricingPlansById, isDbss) {
  if (isDbss) {
    return pathOr([], ['Items'], shoppingCart).some(function (item) {
      var productMetadataPricingPlan = productMetadataPricingPlansById[item.Details.PricingPlan.Id];
      if (productMetadataPricingPlan && productMetadataPricingPlan.PricingPlanBillerRuleInstances) {
        var billerRuleInstances = [].concat(_toConsumableArray(productMetadataPricingPlan.PricingPlanBillerRuleInstances.RecurringBillerRuleInstances || []), _toConsumableArray(productMetadataPricingPlan.PricingPlanBillerRuleInstances.OneTimeBillerRuleInstances || []));
        return billerRuleInstances.some(function (billerRuleInstance) {
          return billerRuleInstance.BillerRuleConfigurationChargeDetails.CycleLevel !== BILLER_RULE_CYCLE_LEVEL.ITEM;
        });
      }
    });
  }
});
export var BillingEffectiveDateConfigurationSelector = createImmutableSelector([ProductOrderSelector], function (productOrder) {
  return productOrder.billingEffectiveDateConfiguration || EMPTY_OBJECT;
});
export var BillingEffectiveDateSettingsSelector = createImmutableSelector([BillingEffectiveDateConfigurationSelector], function (billingEffectiveDateConfiguration) {
  return {
    minimumDate: billingEffectiveDateConfiguration.MinBillingEffectiveDate,
    pastDateMaxLength: billingEffectiveDateConfiguration.PastBillingEffectiveDateMaxLength
  };
});
export var BillingEffectiveDateOptionsSelector = createImmutableSelector([BillingEffectiveDateConfigurationSelector], function (billingEffectiveDateConfiguration) {
  return billingEffectiveDateConfiguration.OrderExecutionToBillingEffectiveDateIntentions || EMPTY_ARRAY;
});